import { render, staticRenderFns } from "./ImportEventForm.vue?vue&type=template&id=23fb05ec&lang=pug"
import script from "./ImportEventForm.vue?vue&type=script&lang=js"
export * from "./ImportEventForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports